<app-modal-container>
  <div class="modal-header-content">
    {{ 'migrate_workspace' | translate }}
  </div>
  <div class="modal-body-content migrate-workspace-confirmation-modal-content">
    <div class="row">
      <div class="col-12">
        <p class="body-content-heading">{{ 'migrate_workspace_modal_body' | translate: [tenantName] }}</p>
      </div>
    </div>

    <div class="row">
      @for (workspaceName of workspacesNames; track workspaceName) {
        <div class="col-12">
          <p class="workspace-name padding-left-md padding-right-md">{{ workspaceName }}</p>
        </div>
      }
      <div class="col-12 text-black">
        {{ 'migrate_workspace_modal_warning' | translate }}
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12 d-flex align-items-center">
        <input type="checkbox" [(ngModel)]="confirmed" id="confirmation" />
        <label role="checkbox" for="confirmation" class="ms-2">
          {{ 'migrate_workspace_modal_confirmation' | translate }}
        </label>
      </div>
    </div>
  </div>
  <div class="modal-footer-content">
    <div class="row justify-content-between">
      <div class="col-auto">
        <button id="cancel" class="btn btn-outline-primary" (click)="cancelled = true; confirmed = false; container.closeModal()">
          {{ 'form_cancel' | translate }}
        </button>
      </div>
      <div class="col-auto">
        <button id="action" class="btn btn-primary" [disabled]="!confirmed" (click)="cancelled = false; container.closeModal()">
          {{ 'migrate_workspace' | translate }}
        </button>
      </div>
    </div>
  </div>
</app-modal-container>
